/* external links new window */
var links = document.links;
if (links.length > 0) {
  for(var i = 0; i < links.length; i++) {
    if (links[i].hostname != window.location.hostname)
      links[i].target = '_blank'
  }
}

// table full row links
const tableBody = document.querySelector('.link_table tbody');
if (tableBody) {
	const rowNodes = tableBody.querySelectorAll('tr');
	rowNodes.forEach(function (element) {
		element.addEventListener('click', function () {
		    var link = element.dataset.url;
		    window.location.href = link;
		});
	});
}

/* print page */
const printBtn = document.getElementById('printBtn');
if (printBtn) {
	printBtn.addEventListener('click', function () {
	    window.print();
	})
}

/* embed iframe responisve */
var wrap = (query, tag) => {
  document.querySelectorAll( query ).forEach( elem => {
    const div = document.createElement(tag);
    elem.parentElement.insertBefore(div, elem);
    div.appendChild(elem);
    div.className = 'embed-container';
  });
};

wrap('iframe', 'div');